import { slsClient } from 'clients/slsClient'
import { History } from 'history'
import { Dispatch } from 'redux'
import { clearUser } from 'redux/reducers/users'

export const handleAccountLocked = async (history: History<unknown>, dispatch: Dispatch<any>) => {
  // show lockout page
  history.push('/account-temporarily-locked')
  await slsClient.logout()
  dispatch(clearUser())
}
